import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { Footer } from './components/Footer';
import { ThankYou } from './components/ThankYou';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  const MainContent = () => <div className="font-sans text-black" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
      </main>
      <Footer data-id="element-3" />
    </div>;
  // Redirect component that performs the redirect
  const MeetRedirect = () => {
    useEffect(() => {
      window.location.replace('https://teams.microsoft.com/meet/38930804206887?p=jiTX40nHg22NkUwgoC');
    }, []);
    return null;
  };
  return <>
      <GoogleTagManager data-id="element-4" />
      <BrowserRouter data-id="element-5">
        <Routes data-id="element-6">
          <Route path="/" element={<MainContent data-id="element-8" />} data-id="element-7" />
          <Route path="/thankyou" element={<ThankYou data-id="element-10" />} data-id="element-9" />
          <Route path="/meet" element={<MeetRedirect data-id="element-12" />} data-id="element-11" />
        </Routes>
      </BrowserRouter>
    </>;
}